const meetingResolutionStatuses = Object.freeze({
  accepted: 1,
  rejected: 2,
  not_resolved: 3,
  sans_vote: 4,
  // status for Demarre le vote
  started: 5,
  corrected: 6,
  rejected_lack_of_majority: 7,
  not_voted: 8, // not soumis au vote
});

export { meetingResolutionStatuses };
